const getPublishCopy = () => {
    return (
        `By checking this box, I confirm that the information provided is true and correct to the best of my knowledge. ` +
        `I understand that I am solely responsible for the accuracy, reliability, and completeness of the submitted content. ` +
        `DEP acts only as a platform provider and does not verify or assume liability for any errors, omissions, or misrepresentations. ` +
        `Any consequences resulting from inaccurate or incomplete information are the sole responsibility of the submitter.`
    );
};

export { getPublishCopy };
